import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import type { Schedule } from '@/common/api/types/schedules';
import { getSchedulesByItemIds } from '@/features/settings/work-integrations/api/schedules';
import { workIntegrationsQueryKeys } from '@/features/settings/work-integrations/queryKeys';

export const useGetSchedulesByItemIds = (
  itemIds: number[],
  staleTime?: number,
  enabled: boolean = true,
) => {
  const allItemIdsSet = useMemo(() => new Set(itemIds), [itemIds]);

  return useQuery<Record<number, Schedule>, Error>({
    queryKey: workIntegrationsQueryKeys.schedules({ itemIds: allItemIdsSet }),
    queryFn: () => getSchedulesByItemIds(allItemIdsSet),
    enabled: enabled && itemIds.length > 0,
    placeholderData: (previousData) => previousData,
    ...(staleTime !== undefined && { staleTime }),
  });
};
